import { LoadingButton } from '@mui/lab';
import { Box, Button, FormControl, TextField } from '@mui/material';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';

const defaultValues = {
  invoiceNumber: '',
};

export const InvoiceNumberForm = ({ onSubmit, onBack, loading = false }) => {
  const {
    handleSubmit,
    reset,
    register,
    formState: { errors, isSubmitted },
  } = useForm({ defaultValues });

  useEffect(() => {
    reset(defaultValues);
  }, [reset]);

  return (
    <Box
      component="form"
      onSubmit={handleSubmit(data =>
        onSubmit?.({
          invoiceNumber: Number.parseInt(data.invoiceNumber, 10),
        }),
      )}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        pt: 1,
        minWidth: 300,
      }}
    >
      <FormControl variant="standard" sx={{ minWidth: 280 }}>
        <TextField
          autoFocus
          label="شماره فاکتور"
          variant="standard"
          type="number"
          inputProps={{ inputMode: 'numeric' }}
          {...register('invoiceNumber', {
            required: 'شماره فاکتور الزامی است',
            validate: value =>
              Number.isFinite(Number.parseInt(value, 10)) ||
              'شماره فاکتور معتبر نیست',
          })}
          error={isSubmitted ? !!errors.invoiceNumber : false}
          helperText={isSubmitted ? errors.invoiceNumber?.message : null}
        />
      </FormControl>

      <Box sx={{ display: 'flex', gap: 1 }}>
        {onBack ? (
          <Button onClick={onBack} variant="contained" disabled={loading}>
            بازگشت
          </Button>
        ) : null}
        <LoadingButton
          type="submit"
          color="warning"
          variant="contained"
          loading={loading}
          sx={{ minWidth: 120 }}
        >
          ثبت
        </LoadingButton>
      </Box>
    </Box>
  );
};
